var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-list',_vm._b({},'v-list',_vm.$attrs,false),[_vm._t("top"),_vm._l((_vm.filteredStruct),function(item,index){return _c('item',{key:index,attrs:{"item":item}})}),_vm._t("bottom")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }